import { Col, FormControl, FormGroup, FormLabel, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import InputDecimal from "../../../components/Forms/Element/InputDecimal";
import InputDate from "../../../components/Forms/Element/InputDate";
import EmployeeSelect from "../../../components/Custom/Main/Employee/EmployeeSelect";
import StatusCheckBox from "../../../components/Common/StatusCheckbox";
import AsteriskRequired from "../../../components/Common/AsteriskRequired";
import FormSection from "../../../components/Common/Form/FormSection";
import { convertStatusToBoolean } from "../../../../utils/ConverterUtils";
import { parseYYYMMDDToDate } from "../../../../utils/DateUtils";

const Form = (props) => {
    const { t } = useTranslation();
    const { status, setStatus, formik, entityData } = props;

    useEffect(() => {
        if (entityData != null) {
            formik.setFieldValue('percent', entityData.percent);
            formik.setFieldValue('description', entityData.description || '');
            formik.setFieldValue('validFrom', entityData.validFrom ? parseYYYMMDDToDate(entityData.validFrom) : null);
            formik.setFieldValue('validTo', entityData.validTo ? parseYYYMMDDToDate(entityData.validTo) : null);

            if (entityData.employee) {
                formik.setFieldValue('employee', {
                    value: entityData.employee.id,
                    label: entityData.employee.fullName
                });
            }

            setStatus(convertStatusToBoolean(entityData.status));
        }

        // eslint-disable-next-line
    }, [entityData]);

    return (
        <>
            <div className="form-layout form-layout--spaced">
                <FormSection
                    title={t('pot_bonus_agreement_title')}
                    description={t('pot_bonus_agreement_hint')}
                    icon="fa-solid fa-handshake"
                >
                    {/* De onde sai o dinheiro é a única coisa que o operador precisa entender
                        antes de salvar, e é o que o assusta: sem o aviso, ele supõe que está
                        tirando do rateio dos colegas e não cadastra. */}
                    <div className="alert alert-info d-flex align-items-center mb-3" role="alert">
                        <i className="fa-solid fa-circle-info me-2" aria-hidden="true"></i>
                        <span>{t('pot_bonus_source_alert')}</span>
                    </div>

                    <Row className="g-3">
                        <Col md={6}>
                            <FormGroup>
                                <FormLabel>{t('employee')} <AsteriskRequired /></FormLabel>
                                <EmployeeSelect
                                    value={formik.values.employee}
                                    onChange={(option) => formik.setFieldValue('employee', option)}
                                    error={formik.errors.employee}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={3}>
                            <FormGroup>
                                <FormLabel>{t('pot_bonus_percent_label')} <AsteriskRequired /></FormLabel>
                                <InputDecimal
                                    name="percent"
                                    onValueChange={(values) => formik.setFieldValue('percent', values.floatValue ?? 0)}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.percent}
                                    error={formik.errors.percent}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={12}>
                            <FormGroup>
                                <FormLabel>{t('description')}</FormLabel>
                                {/* O combinado em uma linha. Meses depois, ninguém lembra por
                                    que aquele colaborador tem 5%, e a resposta precisa estar
                                    no cadastro e não na memória de quem negociou. */}
                                <FormControl
                                    name="description"
                                    maxLength={500}
                                    placeholder={t('pot_bonus_description_placeholder')}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.description}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </FormSection>

                <FormSection
                    title={t('pot_bonus_validity_title')}
                    description={t('pot_bonus_validity_hint')}
                    icon="fa-solid fa-calendar-days"
                >
                    <div className="alert alert-info d-flex align-items-center mb-3" role="alert">
                        <i className="fa-solid fa-circle-info me-2" aria-hidden="true"></i>
                        <span>{t('pot_bonus_validity_alert')}</span>
                    </div>

                    <Row className="g-3">
                        <Col md={4}>
                            <FormGroup>
                                <FormLabel>{t('valid_from')} <AsteriskRequired /></FormLabel>
                                <InputDate
                                    selected={formik.values.validFrom}
                                    onChange={(date) => formik.setFieldValue('validFrom', date)}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={4}>
                            <FormGroup>
                                <FormLabel>{t('valid_to')}</FormLabel>
                                <InputDate
                                    selected={formik.values.validTo}
                                    onChange={(date) => formik.setFieldValue('validTo', date)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </FormSection>

                <FormSection
                    title={t('status')}
                    description={t('pot_bonus_status_hint')}
                    icon="fa-solid fa-toggle-on"
                    compact
                >
                    <Row>
                        <Col md={12}>
                            <FormGroup className="mb-0">
                                <StatusCheckBox
                                    name="status"
                                    defaultChecked={status}
                                    checked={status}
                                    onClick={() => setStatus(!status)} />
                            </FormGroup>
                        </Col>
                    </Row>
                </FormSection>
            </div>
        </>
    );
}

export default Form;
